import { SelectOption } from '@fleet-beat/core';

export enum DeviceType {
  UMU1 = 'UMU1',
  UMU3 = 'UMU3',
}

export const DeviceTypeOptions: SelectOption[] = [
  { value: DeviceType.UMU1, label: 'UMU1' },
  { value: DeviceType.UMU3, label: 'UMU3' },
];
